// extracted by mini-css-extract-plugin
module.exports = {"map":"Slider_map__2p7JB","wrapper":"Slider_wrapper__2mHAr","type-row":"Slider_type-row__3OBh_","type-column":"Slider_type-column__2wfE_"};